import Vue from "vue";
import Router from "vue-router";
import { auth } from "../firebase.config";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: "/",
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
  routes: [
    {
      path: "*",
      redirect: "/",
    },
    {
      path: "/",
      component: (resolve) => {
        require(["../views/public/Start"], resolve);
      },
      children: [
        {
          path: "/",
          component: (resolve) => {
            require(["../views/public/Home"], resolve);
          },
        },
        {
          path: "about",
          component: (resolve) => {
            require(["../views/public/About"], resolve);
          },
        },
        {
          path: "allNews",
          component: (resolve) => {
            require(["../views/public/AllNews"], resolve);
          },
        },
        {
          path: "packages",
          component: (resolve) => {
            require(["../views/public/Packages"], resolve);
          },
        },
        {
          path: "support",
          component: (resolve) => {
            require(["../views/public/Support"], resolve);
          },
        },
        {
         props:true,
          path: "newsDetail/:id",
         
          component: (resolve) => {
            require(["../views/public/NewsDetail"], resolve);
          },
        },
       
        {
          path: "login",
          name: "login",
          component: (resolve) => {
            require(["../views/public/Login"], resolve);
          },
          meta: {
            redirectIfLogged: true,
          },
        },
        {
          path: "register",
          component: (resolve) => {
            require(["../views/public/Register"], resolve);
          },
        },
        {
          path: "account",
          name: "account",
          component: (resolve) => {
            require(["../views/public/Account"], resolve);
          },
          meta: {
            requiresAuth: false,
          },
        },
      ],
    },
    {
      path: "/admin",
      component: (resolve) => {
        require(["../views/admin/Admin"], resolve);
      },
      children: [
        {
          path: "/",
          component: (resolve) => {
            require(["../views/admin/Login"], resolve);
          },
          meta: {
            redirectIfLogged: true,
          },
        },
        {
          path: "dashboard/package-requests",
          component: (resolve) => {
            require(["../views/admin/Package-Request"], resolve);
          },
        },
        {
          path: "dashboard/InitialPage",
          component: (resolve) => {
            require(["../views/admin/InitialPage"], resolve);
          },
        },
        {
          path: "dashboard/contact-requests",
          component: (resolve) => {
            require(["../views/admin/Contact-Request"], resolve);
          },
        },
        {
          path: "dashboard/requestsClaim",
          component: (resolve) => {
            require(["../views/admin/RequestsClaim"], resolve);
          },
        },
        {
          path: "dashboard/corousel",
          component: (resolve) => {
            require(["../views/admin/Carousel"], resolve);
          },
        },
        {
          path: "dashboard/corouselMovil",
          component: (resolve) => {
            require(["../views/admin/CarouselMovil"], resolve);
          },
        },
        {
          path: "dashboard/news",
          component: (resolve) => {
            require(["../views/admin/News"], resolve);
          },
        },
        {
          props: true,
          path: "dashboard/news/:id",
          component: (resolve) => {
            require(["../views/admin/New"], resolve);
          },
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  // TODO: Validate the login when that thing be ready
  let currentUser = auth.currentUser;
  let requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  let redirectIfLogged = to.matched.some(
    (record) => record.meta.redirectIfLogged
  );

  if (requiresAuth && !currentUser)
    return next({
      path: "../admin",
    });

  if (redirectIfLogged && currentUser)
    return next({
      path: "../admin/dashboard/InitialPage",
    });

  return next();
});

export default router;
